import { StringHelpers } from "../helpers/string-helpers";
import { TIDataPointToHighChartDataPointMapper } from "../mappers/data-point/ti-chart-point-to-highchart-data-point.mapper";
import { IChartContainer } from "../models/base/chart-container.interface";
import { DrawTradePriceAnnotationModel } from "../models/draw-trade-order/draw-trade-price-annotation.model";
import { TradeOrderDataModel } from "../models/draw-trade-order/trade-order-data.model";
import { IComponent } from "./component.interface";
import { PnlComponent } from "./pnl.component";

export class DrawTradePriceAnnotationComponent implements IComponent {
    public id = StringHelpers.newGuid();

    private element: HTMLElement | null = null;
    private base: IChartContainer;

    private pnlComp: PnlComponent;
    private annotations: Array<DrawTradePriceAnnotationModel> = [];
    // private originalAnnotations: Array<DrawTradePriceAnnotationModel> = [];
    private isRemovingForSwitchingSymbol = false;
    private hasAnyLimitOrders = false;

    constructor(base: IChartContainer) {
        this.base = base;
        // this.subscribeFake();
        this.subscribe();
        this.base.tiChartSeries?.subscribeExtremeChange(this.id, () => {
            // console.log('subscribeExtremeChange')
            const chartStyle = this.base.tiChartSeries?.chartStyleSettings;
            const nonChartMode = chartStyle?.nonNormalChartMode();
            if (nonChartMode && this.annotations?.length) {
                this.draw();
            } else {
                setTimeout(() => {
                    this.setPosition();
                }, 50);
            };
        });
        this.base.tiChartSeries?.subscribeRedrawChange(this.id, () => {
            // console.log('subscribeRedrawChange')
            const chartStyle = this.base.tiChartSeries?.chartStyleSettings;
            const nonChartMode = chartStyle?.nonNormalChartMode();
            if (nonChartMode && this.annotations?.length) {
                // this.draw();
            } else {
                setTimeout(() => {
                    this.setPosition();
                }, 50);
            }
        });
        this.base.tiChartSeries?.subscribeChartLoad(this.id, () => {
            const chartStyle = this.base.tiChartSeries?.chartStyleSettings;
            const nonChartMode = chartStyle?.nonNormalChartMode();
            if (nonChartMode && this.annotations?.length) {
                this.draw();
                
                setTimeout(() => {                
                    this.draw();
                    setTimeout(() => {                
                        this.draw();
                    }, 500);
                }, 1000);
            }
        });
        this.onResize();
    }

    public createElement() {
        const element = document.createElement('div');
        element.className = 'trade-order-price-annotations';

        const highchartContainer = this.base.tiChartSeries.element.findFirst('.highcharts-container');
        if (highchartContainer) {
            highchartContainer.insertAdjacentElement('beforeend', element);
            this.element = element;
            this.isRemovingForSwitchingSymbol = false;
        }
    }

    public remove() {
        this.isRemovingForSwitchingSymbol = true;
        this.element?.setInnerHtml('');
        this.element?.remove();
        this.annotations = [];
        // this.originalAnnotations = [];

        try {
            this.primitiveRendererImage?.destroy();
            this.primitiveRendererImage = null;
        } catch {}

        try {
            this.riskReward?.destroy();
            this.riskReward = null;
        } catch {}

        this.isRemovingForSwitchingSymbol = false;
    }

    private drawFromSubscribeTimer: any;
    private subscribe() {
        this.base.chartService.subscribeDrawTradePriceAnnotations((data: Array<DrawTradePriceAnnotationModel>) => {
            if (this.isRemovingForSwitchingSymbol || this.base.tiChartSeries?.chartStyleSettings?.advancedOEPPopoutMode) {
                return;
            }

            this.annotations = data;

            this.draw();
            clearTimeout(this.drawFromSubscribeTimer);
            this.drawFromSubscribeTimer = setTimeout(() => {
                this.draw();
            }, 200);
        });
        this.base.chartService.subscribeDrawTradeOrdersData((tradeOrders: Array<TradeOrderDataModel>) => {
            this.hasAnyLimitOrders = tradeOrders.filter(x => x.tradeType?.toLowerCase() != 'market').length > 0;
        });
    }

    private draw() {
        if (this.isRemovingForSwitchingSymbol) {
            return;
        }

        this.element?.setInnerHtml('');

        const isPrimitiveMode = this.base.tiChartSeries?.chartStyleSettings?.primitiveMode;
        let badged = ``;
        let badgedStyle = ``;

        if (isPrimitiveMode) {
            badged = `<div class="badged">{sellOrBuy}</div>`;
            badgedStyle = `
            .last-price-wrapper.{class} .badged {
                background-color: var(--trade_entryprice-bg-badged-color);
                cursor: default;
                color: rgb(255, 255, 255);
                font-size: 10px;
                font-weight: normal;
                text-align: center;
                margin: 0;
                line-height: 1.2;
                white-space: nowrap;
                height: 14px;
                border-radius: 4px;
                position: absolute;
                top: 0;
                right: 125.5px;
                width: 32px;
                z-index: 4;
            }
                
            .last-price-wrapper.{class} .badged.left {
                right: 170.5px;
            }`;
        }

        const template = `<div class="last-price-wrapper {class}">
            <div class="last-price">
                <p>{value}</p>
                ${badged}
                <div class="line"></div>
            </div>
        </div>
        <style>
            .last-price-wrapper.{class} {
                background-color: var(--{class}-bg-color);
                z-index: 22;
            } 
            .last-price-wrapper.{class} .line {
                position: absolute;
                right: 0px;
                top: 50%;
                background-color: var(--{class}-bg-color);
                height: 1px;
            }
            .last-price-wrapper.{class} .last-price p {
                z-index: 1;
                position: relative;
            }
            .last-price-wrapper.{class} .last-price:before {
                border-color: transparent var(--{class}-bg-color) transparent transparent;
            }
            ${badgedStyle}
        </style>`;

        const root = document.documentElement;

        for (const item of this.annotations) {
            const className = item.name.split(' ').join('').replace(/[^\w\s]/gi, '').toLowerCase();
            let html = template.split('{class}').join(className).replace('{value}', item.label);
            html = html.replace('{sellOrBuy}', !item.isLong ? 'Sell' : 'Buy');

            if (isPrimitiveMode) {
                const color = this.getPrimitiveColor(item, false);
                root.style.setProperty('--' + className + '-bg-color', color);

                const redGreencolor = this.getPrimitiveColor(item, true);
                root.style.setProperty('--trade_entryprice-bg-badged-color', redGreencolor);
            } else {
                root.style.setProperty('--' + className + '-bg-color', item.color.toRGB());
            }

            const div = document.createElement('div');
            div.className = 'annotation ' + className;
            div.innerHTML = html;

            item.element = div;
            this.element?.insertAdjacentElement('beforeend', div);
        }

        this.setPosition();
    }

    private getPrimitiveColor(item: DrawTradePriceAnnotationModel, aiGreenOrRed: boolean) {
        if (aiGreenOrRed) {
            return item.isLong ? '#006B17' : '#A81F1F';
        }

        return item.color.toRGB();
        // return isLong ? '#006B17' : '#A81F1F';
    }

    public setPosition() {
        if (!this.pnlComp) {
            this.pnlComp = this.base.getComponentsByType(PnlComponent)?.[0] as PnlComponent;
        }

        if (this.base.tiChartSeries?.chartStyleSettings?.primitiveMode) {
            this.setPositionForPimitiveMode();
        } else {
            this.setPositionForNonPrimitiveMode();
        }
    }
    
    private primitiveRendererImage: any = null;
    private setPositionForPimitiveMode() {
        if (!this.base.tiChartSeries?.chartStyleSettings || !this.base.tiChartSeries?.highStockChart?.yAxis?.length || !this.base.tiChartSeries?.highStockChart?.xAxis?.length || !this.annotations?.length) {
            return;
        }

        // console.log('setPositionForPimitiveMode', this.annotations)
        const yAxis: any = this.base.tiChartSeries.highStockChart.yAxis?.[0];
        const xAxis: any = this.base.tiChartSeries.highStockChart.xAxis?.[0];
        const series: any = this.base.tiChartSeries.highStockChart.series?.[0];
        if (!yAxis || !xAxis || !series) return;

        for (const item of this.annotations) {
            if (!item.element) {
                continue;
            }

            const currentYValue = yAxis.toPixels(item.y) ?? 0;
            const myHeight = 7;

            const valueTop = (yAxis.toPixels(yAxis.max) ?? 0) - 16;
            const valueBottom = (yAxis.toPixels(yAxis.min) ?? 0) - 16;

            let top = currentYValue - myHeight;

            if (item.y > yAxis.max) {
                top = valueTop;
            } else if (item.y < yAxis.min) {
                top = valueBottom;
            }

            item.element.findFirst('p')?.ifExistThen((el: HTMLElement) => {
                el.setInnerHtml(item.label);
            });

            item.element.findFirst('.last-price-wrapper')?.ifExistThen((el: HTMLElement) => {
                el.style.top = top + 'px';
            });

            const color = this.getPrimitiveColor(item, false);
            const width = Math.abs(this.base.tiChartSeries.element.clientWidth);
            item.element.findFirst('.line')?.ifExistThen((el: HTMLElement) => {
                el.setAttribute('style', `background-color: unset !important; border-top: 1px dotted ${color} !important; width: ${width}px;`);
            });

            try {
                this.primitiveRendererImage?.destroy();
                this.primitiveRendererImage = null;
            } catch {}
            
            const exactBrowserEntryX = this.base.tiChartSeries.getCurrentXValueFromInitialDataPoints(item.startTimeT);
            const roundedX = Math.round(exactBrowserEntryX);
            const icon = this.getCircleIcon(color);

            let dataPoint = this.base.tiChartSeries.tiChartPoints.find(x => x.xValue == roundedX);
            let xValue = NaN;
            if (dataPoint) {
                xValue = dataPoint.xValue;
                dataPoint.close = item.y;
                
                const pointIndex = series.points.findIndex((x: any) => x?.x == xValue);
                const point = series.points[pointIndex];
                const lastHighChartDataPoint = TIDataPointToHighChartDataPointMapper.toHighChartDataPoint(this.base.tiChartSeries,  dataPoint);
                
                point?.update(lastHighChartDataPoint, false); 
            }

            if (!isNaN(xValue)) {
                const iconX = xAxis.toPixels(xValue) - 5;
                const iconY = yAxis.toPixels(item.y, true) - 4;
    
                this.primitiveRendererImage = this.base.tiChartSeries.highStockChart.renderer.image(icon, iconX, iconY, 10, 10)
                .attr({
                    zIndex: 9
                })
                .add();
                
                item.element.findFirst('.last-price-wrapper .badged')?.ifExistThen((el: HTMLElement) => {
                    const rect = el.getBoundingClientRect();
                    const left = rect.left - 5;
                    const right = rect.left + rect.width + 5;
                    const top = rect.top - 5;
                    const bottom = rect.top + rect.height + 5;
                    if ((iconX >= left && iconX <= right) || (iconY >= top && iconY <= bottom)) {
                        el.classList.add('left');
                    }
                });
            }
        }

        setTimeout(() => {
            this.base.tiChartSeries?.highStockChart?.redraw();
        }, 300);
    }

    private setPositionForNonPrimitiveMode() {
        if (!this.base.tiChartSeries?.chartStyleSettings || !this.base.tiChartSeries?.highStockChart?.yAxis?.length || !this.base.tiChartSeries?.highStockChart?.xAxis?.length || !this.annotations?.length) {
            return;
        }

        const mainChartSerie: any = this.base.tiChartSeries.highStockChart.series[0]
        const yAxis: any = this.base.tiChartSeries.highStockChart.yAxis[0]
        const xAxis = this.base.tiChartSeries.highStockChart.xAxis[0]

        for (const item of this.annotations) {
            if (!item.element) {
                continue;
            }

            const currentYValue = yAxis.toPixels(item.y) ?? 0;
            const myHeight = 7;

            const valueTop = (yAxis.toPixels(yAxis.max) ?? 0) - 16;
            const valueBottom = (yAxis.toPixels(yAxis.min) ?? 0) - 16;

            let top = currentYValue - myHeight;
            let hide = false;
            let hideLine = false;

            if (item.y > yAxis.max || valueTop > top) {
                top = valueTop;
                hide = true;
            } else if (item.y < yAxis.min || top > valueBottom) {
                top = valueBottom;
                hide = true;
            }

            const itemX = this.annotations.find((x: DrawTradePriceAnnotationModel) => x.name == item.name)?.x ?? item.x;
            let roundedX = Math.round(itemX);
            let point = mainChartSerie.points.find((x: any) => x.x == roundedX);

            if (!point) {
                roundedX = this.base.tiChartSeries.tiChartPoints.find(x => x.startTimeT == item.startTimeT)?.xValue;
                point = mainChartSerie.points.find((x: any) => x.x == roundedX);
            }
            
            const currentXValue = xAxis.toPixels(roundedX) ?? 0;
            let width = Math.abs(this.base.tiChartSeries.element.clientWidth - currentXValue);

            const lastProcessedXData = mainChartSerie.processedXData[mainChartSerie.processedXData.length - 1];
            const selectedAccountHasShares = this.pnlComp.selectedAccount && !this.pnlComp.isSelectedAccountFlatten();
            if (lastProcessedXData < roundedX || selectedAccountHasShares || this.hasAnyLimitOrders) {
                hideLine = true;
                hide = true;
            } else if (!mainChartSerie.processedXData.some((x: number) => x == roundedX)) {
                width = this.base.tiChartSeries.element.clientWidth;
                // TraceLoggingHelpers.log('draw-trade-price-annotation processedXData not found ')
            }

            item.element.findFirst('p')?.ifExistThen((el: HTMLElement) => {
                el.setInnerHtml(item.label);
            });

            item.element.findFirst('.last-price-wrapper')?.ifExistThen((el: HTMLElement) => {
                el.style.top = top + 'px';
            });

            item.element.findFirst('.line')?.ifExistThen((el: HTMLElement) => {
                if (hideLine) {
                    el.style.width = '0px';
                    return;
                }

                // TraceLoggingHelpers.log('draw-trade-price-annotation point ', point)
                const pointWidth = point && point.pointWidth ? point.pointWidth / 2 : 0;
                // el.style.width = width > 0 ? (width + spacingRight + pointWidth) + 'px' : '0px';
                el.style.width = width > 0 ? (width + pointWidth) + 'px' : '0px';
            });

            if (hide) {
                item.element.addClass('hidden');
            } else {
                item.element.removeClass('hidden');
            }
        }

        this.drawRiskReward(this.annotations.find(x => x.stopPrice != null && x.targetPrice != null));
    }

    private riskReward: any = null;
    private drawRiskReward(entry?: DrawTradePriceAnnotationModel) {
        const chart: any = this.base.tiChartSeries?.highStockChart;
        const points = chart?.series?.[0]?.points;

        try { this.riskReward?.destroy(); } catch {}
        this.riskReward = null;

        if (!chart || !points?.length || !entry?.y || entry.stopPrice == null || entry.targetPrice == null) {
            return;
        }

        const yAxis = chart.yAxis[0];
        const xAxis = chart.xAxis[0];

        // same span as DrawAITrade: entry bar through the last bar
        const entryX = this.base.tiChartSeries.tiChartPoints.find(x => x.startTimeT == entry.startTimeT)?.xValue ?? Math.round(entry.x);
        const bars = points.filter((p: any) => p.x >= entryX);
        if (!bars.length) {
            return;
        }

        // clamp to the price pane, not chart.plotHeight - that spans the volume pane too
        const clampX = (x: number) => Math.min(Math.max(x, xAxis.left), xAxis.left + xAxis.width);
        const clampY = (y: number) => Math.min(Math.max(y, yAxis.top), yAxis.top + yAxis.height);

        const halfBar = (bars[0].pointWidth ?? 0) / 2;
        const left = clampX(xAxis.toPixels(bars[0].x) - halfBar);
        const right = clampX(xAxis.toPixels(bars[bars.length - 1].x) + halfBar);
        const width = right - left;

        const yEntry = clampY(yAxis.toPixels(entry.y));
        const yStop = clampY(yAxis.toPixels(entry.stopPrice));
        const yTarget = clampY(yAxis.toPixels(entry.targetPrice));

        // legacy DrawAITrade lightens bars past exitTime (risk-on); split the band there
        const exitBarX = entry.exitStartTimeT == null ? null
            : this.base.tiChartSeries.tiChartPoints.find(x => x.startTimeT == entry.exitStartTimeT)?.xValue;
        const splitPx = exitBarX == null ? null : clampX(xAxis.toPixels(exitBarX) - halfBar);

        // vertical fade towards the entry line, strongest at the stop / target edge; peak alpha per section
        const grad = (fromEntry: boolean, color: string, peak: number) => ({
            linearGradient: { x1: 0, y1: fromEntry ? 0 : 1, x2: 0, y2: fromEntry ? 1 : 0 },
            stops: [[0, `rgba(${color},0.03)`], [1, `rgba(${color},${peak})`]]
        });

        const g = chart.renderer.g('risk-reward-poc').attr({ zIndex: 3 }).add();
        const band = (x: number, w: number, yFrom: number, yTo: number, color: string, peak: number) => {
            if (w <= 0) {
                return;
            }
            chart.renderer.rect(x, Math.min(yFrom, yTo), w, Math.abs(yTo - yFrom))
                .attr({ fill: grad(yTo > yFrom, color, peak) }).add(g);
        };

        const zones = (x: number, w: number, peak: number) => {
            band(x, w, yEntry, yStop, '220,40,40', peak);
            band(x, w, yEntry, yTarget, '30,160,60', peak);
        };

        if (splitPx == null) {
            zones(left, width, 0.45);
        } else {
            zones(left, splitPx - left, 0.45);   // entry -> exit: solid
            zones(splitPx, right - splitPx, 0.18); // exit -> current: risk-on faded
        }

        const center = left + width / 2;
        // like SetProfitConfiguration: drop the word first, then the whole label, when the zone is too small
        const label = (word: string, value: number | null, yEdge: number, color: string) => {
            const height = Math.abs(yEdge - yEntry);
            if (value == null || height < 12) {
                return;
            }

            // baseline just inside the stop / target edge
            const y = yEdge < yEntry ? yEdge + 11 : yEdge - 3;
            const amount = '$' + Math.round(value).toLocaleString();
            const el = chart.renderer.text(`${word} ${amount}`, center, y)
                .attr({ align: 'center' }).css({ color, fontSize: '10px' }).add(g);

            if (el.getBBox().width > width - 8) {
                el.attr({ text: amount });
                if (el.getBBox().width > width - 8) {
                    el.destroy();
                }
            }
        };

        label('RISK', entry.risk, yStop, '#d32f2f');
        label('REWARD', entry.reward, yTarget, '#1b8a3a');

        this.riskReward = g;
    }

    private resizeTimmer = null as any;
    private onResize() {
        this.base.domEvents.onResize(this.id, () => {
            clearTimeout(this.resizeTimmer);
            this.resizeTimmer = setTimeout(() => {
                this.setPosition();
            }, 50);
        });
    }

    private getCircleIcon(color: string): string {
        // SVG source code
        const svgSource =  `
            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="10px" height="10px">
            <defs>
            <style>
                .cls-1 {
                fill: transparent;
                stroke: ${color};
                stroke-miterlimit: 10;
                stroke-width: 9px;
                }
        
                .cls-2 {
                fill: ${color};
                stroke-width: 0px;
                }
            </style>
            </defs>
            <circle class="cls-1" cx="50" cy="50" r="44.85" />
            <circle class="cls-2" cx="50" cy="50" r="14.32" />
        </svg>
        `;

        const dataUrl = 'data:image/svg+xml,' + encodeURIComponent(svgSource);
        return dataUrl;
    }
}